import { render, staticRenderFns } from "./TheToolbar.vue?vue&type=template&id=2c268b86"
import script from "./TheToolbar.ts?vue&type=script&lang=ts&external"
export * from "./TheToolbar.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports